import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../../constants";

const ModalHeader = styled.div`
  background: #d97706;
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 16px 20px 20px;
  max-height: 400px;
  overflow-y: auto;
`;

const WarningCard = styled.div`
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-left: 4px solid #d97706;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const BoxLabel = styled.div`
  font-size: 0.8em;
  font-weight: 600;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 6px;
`;

const WarningItem = styled.div`
  font-size: 0.9em;
  font-weight: 600;
  color: #78350f;
  padding: 2px 0;
`;

const FooterBar = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
`;

const CloseBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

/**
 * Modal component for displaying block warnings
 */
const WarningModal = React.memo(({ isOpen, onClose, warnings }) => {
  if (!warnings || warnings.length === 0) {
    return null;
  }

  return (
    <ReactModal
      isOpen={isOpen}
      style={MODAL_STYLES}
      onRequestClose={onClose}
      appElement={document.getElementById("root")}
    >
      <ModalHeader>
        Block Warnings
        <CloseButton onClick={onClose}>&times;</CloseButton>
      </ModalHeader>
      <ModalBody>
        {warnings.map((message) => (
          <WarningCard key={`${message.blockWarnings[0]}-${message.boxNumber}`}>
            <BoxLabel>Box {message.boxNumber}</BoxLabel>
            {message.blockWarnings.map((warning) => (
              <WarningItem key={`${message.boxNumber}-${warning}`}>
                {warning}
              </WarningItem>
            ))}
          </WarningCard>
        ))}
      </ModalBody>
      <FooterBar>
        <CloseBtn onClick={onClose}>Close</CloseBtn>
      </FooterBar>
    </ReactModal>
  );
});

WarningModal.displayName = "WarningModal";

WarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      blockWarnings: PropTypes.arrayOf(PropTypes.string).isRequired,
      boxNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
};

export default WarningModal;
